import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'

const PreceptorInformation = (props) => {
  const { student } = props

  const { firestore } = useFirebase()
  const { 
    getPreceptorsBySchoolId, preceptors, updateDocFromCollection
  } = firestore

  const [open, setOpen] = useState(false)

  const [edit, setEdit] = useState('')

  const [preceptor, setPreceptor] = useState()
  const [schoolPreceptors, setSchoolPreceptors] = useState([])

  const handlePreceptorChanged = (event) => {
    const id = event.target.value
    const preceptor = schoolPreceptors.filter(p => p.id === id)[0]
    setPreceptor(preceptor)
  }

  const onEdit = async () => {
    setOpen(true)
    if (preceptor !== undefined) {
      updateDocFromCollection('students', student.id, {
        'preceptor': preceptor,
        'preceptorId': preceptor.id
      })
    }
    setEdit('')
    setOpen(false)
  }

  const onCancel = () => {
    if (student.preceptor === undefined) {
      setPreceptor(undefined)
      setEdit('')
      return
    }

    if (edit === 'preceptor') {
      const preceptor = student.preceptor
      setPreceptor({
        'id': preceptor.id,
        'name': preceptor.name,
        'email': preceptor.email,
      })
    }

    setEdit('')
  }

  useEffect(() => {
    getPreceptorsBySchoolId(student.schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (student === undefined) return
    // if (student.preceptor === undefined) return
    setPreceptor(student.preceptor)
    // const preceptor = student.preceptor
    // setPreceptor({
    //   'id': preceptor.id,
    //   'name': preceptor.name,
    //   'email': preceptor.email,
    // })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student])

  useEffect(() => {
    if (preceptors === undefined) return
    const found = preceptors.map(preceptor => ({
      'id': preceptor.id,
      'name': preceptor.name,
      'email': preceptor.email,
    }))
    setSchoolPreceptors(found)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preceptors])

  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>PRECEPTOR</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              {
                edit === 'preceptor' ? (
                  <ListItem sx={{ p: 0, py: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControl fullWidth variant='outlined'>
                          <InputLabel shrink id='select-outlined-preceptor'>Preceptores</InputLabel>
                          <Select
                            labelId='select-outlined-preceptor'
                            id='select-outlined-preceptor'
                            onChange={handlePreceptorChanged}
                            value={preceptor}
                            label='Preceptores'
                            notched
                          >
                            { 
                              schoolPreceptors.map((preceptor, index) =>
                                <MenuItem key={`grade_${index}`} value={preceptor.id}>
                                  {preceptor.name}
                                </MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} align='right'>
                        <Button color='lightPurple' disableElevation variant='contained' onClick={onCancel}>
                          <b>Cancelar</b>
                        </Button>
                        <Button color='lightGreen' disableElevation variant='contained' sx={{ ml: 1 }} onClick={onEdit}>
                          <b>Guardar</b>
                        </Button>
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : (
                  <ListItem 
                    // secondaryAction={
                    //   <IconButton edge='end' size='small' onClick={() => setEdit('preceptor')}>
                    //     <EditIcon color='lightPurple' fontSize='small' />
                    //   </IconButton>
                    // } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>{preceptor !== undefined ? preceptor.name : 'Sin preceptor'}</b>} secondary={preceptor !== undefined ? preceptor.email : '' } />
                  </ListItem>
                )
              }
            </List>
          </Grid>
        </Grid>
      </CardContent>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </Card>
  )
}

export default PreceptorInformation